import './DatasetDetailsHeader.scss';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ColumnLayout } from '../../../../modules/common/layouts/columnLayout/ColumnLayout';
import { Loader } from '../../../components/Loader';
import { InputStatus } from '../../../models/error.model';
import { DatasetDetailsOverviewTabContainer } from '../containers/DatasetDetailsOverview.container';
import { DatasetEditablePageHeader } from './DatasetEditablePageHeader';

interface IProps {
  name: string;
  description: string;
  onNameChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
  onNameBlur: () => Promise<void>;
  onDescriptionBlur: () => Promise<void>;
  nameMaxLength: number;
  nameStatus: InputStatus;
  descriptionMaxLength: number;
  descriptionStatus: InputStatus;
  isLoading: boolean;
  authorStatus?: InputStatus;
  termsOfUseStatus?: InputStatus;
  author: string;
  termsOfUse?: string;
  onAuthorBlur: (value: string) => Promise<void>;
  onTermsOfUseBlur: (value: string) => Promise<void>;
  onAuthorChange: (value: string) => void;
  onTermsOfUseChange: (value: string) => void;
}

export const DatasetDetailsHeader = observer((props: IProps): ReactElement => {
  return (
    <div className='dataset-details-header'>
      <Loader isLoading={props.isLoading}>
        <ColumnLayout
          size='md'
          className='dataset-details-info-form'
        >
          <DatasetEditablePageHeader {...props} />
        </ColumnLayout>
        <DatasetDetailsOverviewTabContainer />
      </Loader>
    </div>
  );
});
